import { padStart, padEnd } from 'lodash';

export const isValidEthereumAddress = (address: string): boolean => /^0x[0-9A-Fa-f]{40}$/.test(address);

export const removeLeadingZerosFromString = (data: string): string => data.replace(/^0+/, '');

export const padHexNumber = (hex: string, valueSize = 40, excludeOx = false, removeOx = false, fromStart = false): string => {
  const valuePart = removeOx ? (hex ?? '').slice(2) : hex;
  let formatedValuePart = '';
  if (fromStart) {
    formatedValuePart = String(valuePart).toLowerCase();
    formatedValuePart = padStart(formatedValuePart, valueSize, '0');
  } else {
    formatedValuePart = String(valuePart).toLowerCase();
    formatedValuePart = padEnd(formatedValuePart, valueSize, '0');
  }
  return excludeOx === true ? formatedValuePart : `0x${formatedValuePart}`;
};
